import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import App from './App'
import AppErrorBoundary from './components/AppErrorBoundary'
import { TRPCProvider } from './lib/trpc'
import { LanguageProvider } from './contexts/LanguageContext'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { initTelegramWebApp } from './hooks/useTelegram'
import './index.css'
import './v2.css'

// Initialize Telegram WebApp early
initTelegramWebApp()

/** Toasts follow the selected theme. */
function ThemedToaster() {
  const { theme } = useTheme()
  return (
    <Toaster
      position="top-center"
      theme={theme}
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        style: {
          background: 'var(--color-ink-2)',
          color: 'var(--color-bone)',
          border: '1px solid var(--color-line-2)',
          borderRadius: '14px',
          fontSize: '14px',
          opacity: '1',
        },
      }}
    />
  )
}

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

const root = createRoot(rootElement)
root.render(
  <StrictMode>
    <AppErrorBoundary>
      <TRPCProvider>
        <ThemeProvider>
          <LanguageProvider>
            <App />
            <ThemedToaster />
          </LanguageProvider>
        </ThemeProvider>
      </TRPCProvider>
    </AppErrorBoundary>
  </StrictMode>,
)
